import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactZmartaSeConfig } from './presets/contact-zmarta-se.config';
import { globalSe } from './presets/global-se.config';
import { myPageCcd2SeOptions } from './presets/mypage-ccd2-se.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { productConfigLimited } from './presets/product-config.preset';
import { organisationZmartaSeConfig } from './presets/organisation-zmarta-se.config';
import { serviceTrustpilotAxoConfig } from './presets/service-trustpilot-axo.config';
import { sitePathZmartaSeConfig } from './presets/site-path-zmarta-se.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansSeConfig } from './presets/unsecured-loans-se.config';

export const global: GlobalConfig = {
  brand: 'zmarta.se',
  ...globalSe,
};

export const site: SiteConfig = {
  domain: 'zmarta.se',
  name: 'Zmarta',
  theme: {
    name: 'zmarta',
    brand: 'zmarta',
  },
  ...sitePathZmartaSeConfig,
  ...organisationZmartaSeConfig,
  ...contactZmartaSeConfig,
  services: {
    trustpilot: {
      ...serviceTrustpilotAxoConfig,
      businessUnitId: '53f1ed8a000064000579aff2',
    },
    gtm: 'GTM-K48RWG24',
    ga: 'G-TZ0ZPQC264',
    launchDarkly: {
      enabled: true,
      anonymousExperimentsEnabled: false,
    },
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansSeConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: true,
    ...myPageOffersConfig,
    ...myPageCcd2SeOptions,
  },
  externalLinks: [
    { key: 'elskling', loginUrl: 'https://elskling.se' },
    // Receipts on Zmarta's own "My Account" (electricity/insurance) page.
    // Relative same-origin path: it resolves against the origin that served the
    // (reverse-proxied) Overview, i.e. `/min-sida` → https://zmarta.se/min-sida.
    // After MV-2851 the old /mina-sidor reverse-proxies to our MP Overview, so
    // Zmarta moves My Account to /min-sida — a genuine link-out, NOT circular.
    { key: 'zmarta', loginUrl: '/min-sida' },
  ],
};

export const product: ProductConfig = productConfigLimited;
